import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { diasHasta, creditos, fecha, gramos } from "../lib/formato";
import { Aviso, BarraLimite, Panel } from "../componentes/piezas";
import { useIdioma } from "../lib/idioma";
import { useSesionPortal } from "./sesionPortal";
import PortalAvisos from "./PortalAvisos";

/** Resumen del socio: carnet con QR, consumo frente a sus límites, cuota y cartera. */
export default function PortalInicio() {
  const { datos } = useSesionPortal();
  const { t, delServidor, dias: enDias } = useIdioma();
  const [qr, setQr] = useState<string | null>(null);

  const codigo = datos?.socio.codigoAcceso;
  useEffect(() => {
    if (!codigo) return;
    let vigente = true;
    void QRCode.toString(codigo, { type: "svg", margin: 1, width: 220 }).then(
      (svg) => {
        if (vigente) setQr(svg);
      },
    );
    return () => {
      vigente = false;
    };
  }, [codigo]);

  if (!datos) return null;
  const { socio, club, consumo, bloqueo } = datos;
  const dias = diasHasta(socio.fechaCaducidad);

  return (
    <>
      {bloqueo && <Aviso tipo="error">{delServidor(bloqueo)}</Aviso>}
      {!bloqueo && dias !== null && dias <= 30 && (
        <Aviso tipo="atencion">
          {dias < 0
            ? t("inicio.cuotaVencioHace", { dias: enDias(-dias) })
            : dias === 0
              ? t("inicio.cuotaVenceHoy")
              : t("inicio.cuotaVenceEn", { dias: enDias(dias) })}
        </Aviso>
      )}

      <Panel>
        <div className="portal-carnet">
          <div>
            <div className="rotulo">{t("inicio.socio")}</div>
            <h2 style={{ margin: "2px 0 6px" }}>
              {socio.nombre} {socio.apellidos}
            </h2>
            <div className="fila ajustable" style={{ gap: 8 }}>
              <span className="etiqueta verde">
                {t("inicio.numero", { numero: socio.numeroSocio })}
              </span>
              {socio.tipoSocio && (
                <span
                  className="etiqueta"
                  style={{
                    background: `${socio.tipoSocio.color}20`,
                    color: socio.tipoSocio.color,
                  }}
                >
                  {socio.tipoSocio.nombre}
                  {socio.tipoSocio.descuentoPorcentaje > 0
                    ? ` −${socio.tipoSocio.descuentoPorcentaje}%`
                    : ""}
                </span>
              )}
            </div>
            <div className="suave pequeno" style={{ marginTop: 10 }}>
              {club.nombre}
              <br />
              {t("inicio.socioDesde", { fecha: fecha(socio.fechaAlta) })}
              <br />
              {t("inicio.cuotaValidaHasta", {
                fecha: fecha(socio.fechaCaducidad),
              })}
            </div>
          </div>

          <div className="portal-qr">
            {qr ? (
              <div dangerouslySetInnerHTML={{ __html: qr }} />
            ) : (
              <div className="suave pequeno">{t("inicio.generando")}</div>
            )}
            <div className="suave pequeno tabular centrado">
              {socio.codigoAcceso}
            </div>
          </div>
        </div>
        <p className="suave pequeno" style={{ margin: "12px 0 0" }}>
          {t("inicio.ensenaCodigo")}
        </p>
      </Panel>

      <div className="rejilla dos" style={{ marginTop: 16 }}>
        <Panel titulo={t("inicio.tuConsumo")}>
          <div className="columna" style={{ gap: 14 }}>
            <BarraLimite
              consumidoMg={consumo.consumidoHoyMg}
              limiteMg={consumo.limiteDiarioMg}
              etiqueta={t("inicio.hoy")}
            />
            <BarraLimite
              consumidoMg={consumo.consumidoMesMg}
              limiteMg={consumo.limiteMensualMg}
              etiqueta={t("inicio.esteMes")}
            />
          </div>
          <div
            className="fila separada"
            style={{
              marginTop: 14,
              paddingTop: 12,
              borderTop: "1px solid var(--borde)",
            }}
          >
            <span className="suave">{t("inicio.puedesRetirar")}</span>
            <strong className="tabular">{gramos(consumo.disponibleMg)}</strong>
          </div>
        </Panel>

        <Panel titulo={t("inicio.tuCartera")}>
          <div className="valor tabular">{creditos(socio.saldoCentimos)}</div>
          <p className="suave pequeno" style={{ marginBottom: 0 }}>
            {t("inicio.saldoDisponible")}
          </p>
        </Panel>
      </div>

      <div style={{ marginTop: 16 }}>
        <PortalAvisos />
      </div>

      {(club.direccion || club.telefono) && (
        <div style={{ marginTop: 16 }}>
          <Panel titulo={t("inicio.tuClub")}>
            <div className="columna pequeno">
              {club.direccion && (
                <div>
                  {club.direccion}
                  {club.ciudad ? `, ${club.ciudad}` : ""}
                </div>
              )}
              {club.telefono && (
                <div>
                  {t("inicio.telefono")}{" "}
                  <a href={`tel:${club.telefono}`}>{club.telefono}</a>
                </div>
              )}
            </div>
          </Panel>
        </div>
      )}
    </>
  );
}
